export const MAX_TIERS_COUNT = 10;
